// variables that are NOT prefixed with 'PUBLIC_' won't work in <script> tag and general frontend code!
const {
  STRAPI_URL,
  PUBLIC_FACEBOOK_GROUP_URL,
  SUPPORT_URL,
  INSTAGRAM_URL,
  PRESS_KIT_URL,
  STATUS_URL,
  COPYRIGHT_URL,
  PUBLIC_GOOGLE_PLAY_URL,
  PUBLIC_APPLE_STORE_URL,
  YOUTUBE_URL,
  PUBLIC_GOOGLE_SITE_KEY,
  GOOGLE_SECRET_KEY,
  SENDY_API_KEY,
  PUBLIC_SUPPORT_EMAIL,
  PUBLIC_HOTEL_INVITE_URL,
  // APP_MODE,
  PUBLIC_APP_MODE,
  PUBLIC_PARSE_URL,
  PUBLIC_PADDLE_VENDOR_ID
} = import.meta.env;

const [appName, envMode] = PUBLIC_APP_MODE.split("-") as [AppName, EnvMode];

const environment = {
  appName,
  envMode,
  isDev: import.meta.env.DEV,
  isProd: !import.meta.env.DEV,
  isServer: import.meta.env.SSR,
  isBibino: appName === "bibino",
  isBarkio: appName === "barkio",
  isCamerito: appName === "camerito",
  isNotBibino: appName !== "bibino",
  isNotBarkio: appName !== "barkio",
  isNotCamerito: appName !== "camerito"
};

const links = {
  facebookGroupUrl: PUBLIC_FACEBOOK_GROUP_URL,
  supportUrl: SUPPORT_URL,
  instagramUrl: INSTAGRAM_URL,
  pressKitUrl: PRESS_KIT_URL,
  statusUrl: STATUS_URL,
  copyrightUrl: COPYRIGHT_URL,
  googlePlayUrl: PUBLIC_GOOGLE_PLAY_URL,
  appleStoreUrl: PUBLIC_APPLE_STORE_URL,
  youtubeUrl: YOUTUBE_URL,
  hotelInviteUrl: PUBLIC_HOTEL_INVITE_URL
};

const apiUrls = {
  strapiUrl: STRAPI_URL,
  parseUrl: PUBLIC_PARSE_URL
};

const apiKeys = {
  googleSiteKey: PUBLIC_GOOGLE_SITE_KEY,
  googleSecretKey: GOOGLE_SECRET_KEY,
  sendyApiKey: SENDY_API_KEY,
  paddleVendorKey: PUBLIC_PADDLE_VENDOR_ID
};

const emails = {
  supportEmail: PUBLIC_SUPPORT_EMAIL
};

export { links, apiUrls, apiKeys, emails };
export default environment;
